import * as React from 'react';

export default class Drawer extends React.Component {
    drawerContainerRef;
    renderChildDrawer;

    constructor(props) {
        super(props);
        this.state = {
            shouldDisplayChildDrawer: true,
            childDrawerOpen: false,
            childDrawerComponent: null,
            renderChildDrawer: null,
            resetChildDrawer: false
        };
        this.drawerContainerRef = React.createRef();
        this.setState = this.setState.bind(this);
        this.openDrawerCallback = this.openDrawerCallback.bind(this);
        this.closeChildDrawer = this.closeChildDrawer.bind(this);
    }

    componentDidMount() {
        this.drawerContainerRef.current.addEventListener('click', e => this.handleOutsideClick(e));
        this.setState({
            renderChildDrawer: (component) => <Drawer
                shouldDisplayChildDrawer={false}
                isOpen={this.state.childDrawerOpen}
                closeDrawer={this.closeChildDrawer}
                render={component}/>
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.reff && this.props.isOpen !== nextProps.isOpen && nextProps.isOpen)
            this.props.reff.current.scrollTop = 0;
    }

    handleOutsideClick(event) {
        if (event.target.contains(this.drawerContainerRef.current))
            this.props.closeDrawer();
    }

    openDrawerCallback(component) {
        this.setState({
            childDrawerOpen: true,
            childDrawerComponent: component,
            resetChildDrawer:false
        });
    }

    closeChildDrawer() {
        this.setState({childDrawerOpen: false, resetChildDrawer:true});
    }

    render() {
        return (
            <div className={`drawer-container ${this.props.isOpen ? 'open' : 'closed'} ${!this.props.shouldDisplayChildDrawer ? 'minifyed' : ''}`}>
                <div className={`drawer-background ${this.props.isOpen ? 'open' : 'closed'}`}
                     ref={this.drawerContainerRef}/>
                <div className={`drawer-component ${this.props.isOpen ? 'open' : 'closed'} ${this.state.childDrawerOpen ? 'wider' : ''} ${!this.props.shouldDisplayChildDrawer ? 'minifyed' : ''}`}
                     id='drawer-component'
                     ref={this.props.reff}>
                    {
                        this.props.children &&
                            React.cloneElement(this.props.children, {
                                openDrawerCallback: this.openDrawerCallback,
                                closeChildDrawer: this.closeChildDrawer,
                                closeDrawer: this.props.closeDrawer,
                                resetChildDrawer: this.state.resetChildDrawer
                            })
                    }
                    {
                        this.props.render && this.props.render()
                    }
                    {
                        this.props.shouldDisplayChildDrawer &&
                        this.state.renderChildDrawer &&
                        this.state.renderChildDrawer(this.state.childDrawerComponent)
                    }

                </div>
            </div>
        )
    }
}
